/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDynamicTemplate = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        clipRule="evenodd"
        d="M3 2H2v18h13v-2H4V4h16v6h2V2h-1zm2 6h2V6H5zm4 0h2V6H9zm4 0h2V6h-2zm4 0h2V6h-2zM5 12h2v-2H5zm0 4h2v-2H5zm4 0h2v-2H9zm4 0h2v-2h-2zm3.167-.417L19.917 11l-.833 3.75L22 16l-5 5 2.084-4.167z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </g>
  </Icon>
);
export { SvgDynamicTemplate as DynamicTemplate };
